import { Box, Button, Checkbox, Chip, Stack, Switch, TableCell, TableRow, Tooltip } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import moment from 'moment';
import { trackActivity } from '../../../utils/mixpanel';
import UploadingIcon from '../../../shared_elements/components/UploadingIcon';
import { PermissionWrapper } from '../../../wrappers';
import AuditPopover from '../../../shared_elements/components/popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { LessMoreComp } from '../../../shared_elements/components';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useSelector } from 'react-redux';
import { Restore as RestoreIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
const invoiceTypeOptions = {
     1:'Reserve' ,
     2:'Rental' ,
     3:'Penalty',
     4:'Debit' ,
     5:'Credit' ,
     9:'Adhoc' ,
     6:'Security Deposit',
    10:'Management Fee',
};

const TaxList = ({ item, onDelete, onView, onEdit, onInvStatus, viewRevisonHistory, toggleBulkOps, bulk }) => {
    const { permission } = useSelector((state) => state.leases);
    const leasePermission = permission?.permissions?.lease_revamp_application?.lease_revamp?.lease_details;
    const status = Array.isArray(leasePermission) ? leasePermission.includes('U') : false;

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Additional Tax lising`, page_type: page_type, })
    }
    const invoiceTypes = item?.invoice_types || [];
    const visibleTypes = invoiceTypes.slice(0, 2);
    const extraCount = invoiceTypes.length - 2;
    return (
        <TableRow>
            <TableCell className="table-actions-list">
                <Box className="icon-container" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "additional_tax", operationType: ['D'] }}>
                        <Checkbox disableRipple style={{ verticalAlign: 'super' }} color="primary" size="small" checked={bulk?.ids?.find(items => items?.id === item?.id) ? true : false} onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)} />
                    </PermissionWrapper>
                    <AuditPopover item={item}>
                        <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                    </AuditPopover>
                    <Tooltip title="Revision History">
                        <RestoreIcon className='revision-history' color="primary" fontSize='small' sx={{ cursor: 'pointer' }} onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} />
                    </Tooltip>
                    <Tooltip arrow title="View">
                        <VisibilityIcon fontSize="small" onClick={() => { onView(); handleItemClicked('ViewIcon') }} color="primary" sx={{ cursor: "pointer" }} />
                    </Tooltip>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "additional_tax", operationType: ['U'] }}>
                        <Tooltip arrow title="Edit">
                            <EditIcon fontSize="small" onClick={() => { onEdit(); handleItemClicked('EditIcon') }} color="primary" sx={{ cursor: "pointer" }} />
                        </Tooltip>
                    </PermissionWrapper>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "additional_tax", operationType: ['D'] }}>
                        <Tooltip arrow title="Delete">
                            <DeleteIcon fontSize="small" onClick={() => { onDelete(); handleItemClicked('DeleteIcon') }} color="error" sx={{ cursor: "pointer" }} />
                        </Tooltip>
                    </PermissionWrapper>
                </Box>
            </TableCell>
            <TableCell sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>{item?.name || '--'}</TableCell>
            <TableCell sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>{item?.tax_percentage || '__'} </TableCell>
            <TableCell sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>
                {visibleTypes.length ? (
                    <>
                        {visibleTypes.map(type => (
                            <Chip
                                style={{ marginRight: "7px" }}
                                size='small'
                                label={invoiceTypeOptions[type] || '--'}
                                variant={'outlined'}
                                color='primary'
                            />
                        ))}
                        {extraCount > 0 && <Chip size='small' label={`+${extraCount}`} variant={'outlined'} />}
                    </>
                ) : '--'}
            </TableCell>
            <TableCell sx={{ cursor: 'pointer' }} onClick={() => { onView(); handleItemClicked('Clicked on Table data') }}>
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "additional_tax", operationType: ['U'] }}
                    noPermissionChild={
                        <Switch checked={item?.status ?? true} size="small" disabled color="primary" />
                    }>
                    <Tooltip arrow title={(item?.status ?? true) ? 'Set Inactive' : 'Set Active'}>
                        <Switch
                            checked={item?.status ?? true}
                            size="small"
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => {onInvStatus(item); handleItemClicked('Switch Status')}}
                            color="primary"
                        />
                    </Tooltip>
                </PermissionWrapper>
                <div style={{display:'inline-block'}}>{item?.status== true? 'Active':'Inactive'}</div>
            </TableCell>
        </TableRow>
    );
};

export default TaxList;
